import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {Helmet} from 'react-helmet';
import { useDispatch, useSelector } from "react-redux";
import AboutUs from "../aboutus";
import Faqs from "../faqs";
import Portfolios from "../portfolios";
import Features from "../features";
import Pricing from "../pricing";
import Services from "../services";
import Teams from "../teams";
import Testimonials from "../testimonials";
import Clients from "../clients";
import Certificate from "../Certificate";
import Contact from "../contact";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What web development services do you offer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I offer full-stack website design, front-end and back-end development, SEO optimization, CMS setup, e-commerce integration, and website redesign."
      }
    },
    {
      "@type": "Question",
      "name": "Do you build both static and dynamic websites?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I develop both static and dynamic websites depending on your project needs, including admin dashboards and CMS integration."
      }
    },
    {
      "@type": "Question",
      "name": "What technologies do you use for web development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I use HTML, CSS, JavaScript, jQuery, Bootstrap, React JS, PHP, WordPress, and other modern tools for fast and scalable websites."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer custom website design or use templates?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I provide 100% custom design tailored to your brand, goals, and user experience requirements. Templates are used only when requested."
      }
    },
    {
      "@type": "Question",
      "name": "Is SEO included in your service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I include basic on-page SEO in every project, and also offer advanced SEO packages to boost ranking and visibility."
      }
    },
    {
      "@type": "Question",
      "name": "Do you build mobile-responsive websites?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all websites I build are fully responsive, meaning they adapt perfectly to mobile phones, tablets, and desktops."
      }
    },
    {
      "@type": "Question",
      "name": "Can you redesign an existing website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I offer complete website redesign services to modernize old sites, improve user experience, and increase conversions."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to complete a website project?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A basic website takes 4-7 days, while more complex projects like eCommerce or custom platforms may take 2-4 weeks."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide maintenance after project delivery?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I offer affordable maintenance packages to keep your website updated, secure, and fast after launch."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help with website speed optimization?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I offer speed optimization services including image compression, lazy loading, minification, and performance audits."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide e-commerce website development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I build user-friendly and secure e-commerce websites using platforms like WooCommerce, Shopify, and custom PHP solutions."
      }
    },
    {
      "@type": "Question",
      "name": "Is content writing included in your service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Content writing is optional. I can provide SEO-friendly content or work with your existing content during development."
      }
    },
    {
      "@type": "Question",
      "name": "Do you integrate contact forms and lead capture?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I integrate lead generation forms, contact forms, WhatsApp chat, and email capture as part of all websites."
      }
    },
    {
      "@type": "Question",
      "name": "Can I manage my website myself after launch?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "If your site uses WordPress or another CMS, I provide training or documentation so you can easily manage it on your own."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer logo design or branding?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can help with logo creation, business branding, and UI/UX design to match your website style."
      }
    },
    {
      "@type": "Question",
      "name": "Do you support multi-language websites?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can develop multilingual websites using translation plugins or custom code based on your target audiences."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help with domain and hosting setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I help register your domain, set up hosting, connect email, and configure everything needed to go live."
      }
    },
    {
      "@type": "Question",
      "name": "Do you work with clients outside India?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I work with international clients across the US, UK, UAE, and other countries via remote collaboration."
      }
    },
    {
      "@type": "Question",
      "name": "What is your experience as a freelance developer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I have 11+ years of experience as a full-stack developer, having completed 1000+ projects for clients globally since 2013."
      }
    },
    {
      "@type": "Question",
      "name": "Can you build landing pages for marketing campaigns?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I create custom landing pages for Google Ads, Facebook campaigns, and lead generation, optimized for conversions."
      }
    }
  ]
}


function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
    <title>Pankaj - Website Designing Services In Gurgaon</title>
  <meta name="description" content="Website Designing Services In Gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India."/>
  <meta name="keywords" content="pankaj, pankj, web designers near me, website designer near me, web designing company in gurgaon, Website Designing Services In Gurgaon, website development company in gurgaon,freelance web designer, web design gurgaon, Website Designers In Gurgaon, web design companies near me, web design company, website designer in gurgaon"/>
<meta property="og:title" content="Pankaj - Website Designing Services In Gurgaon | website development company in gurgaon" />
<meta property="og:description" content="Website Designing Services In Gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<meta property="og:site_name" content="Pankaj - Website Designing Services In Gurgaon | website development company in gurgaon" />
<meta property="og:url" content="https://www.pankj.com/gservices"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj - Website Designing Services In Gurgaon | website development company in gurgaon" />
<meta name="twitter:description" content="Website Designing Services In Gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<link rel="canonical" href="https://www.pankj.com/services" />
        </Helmet>
  <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer1.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
        <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects" id="text3d">Services</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="Website Design Gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
 <Services />
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
